import React from 'react';
import { Link } from 'react-router-dom';
import { getTicketQueueItem } from '../../utils/ticketQueue';

const TicketSummary = ({ ticket, children }) => {
  const fullStatus = ticket.workflow?.current_status_label || ticket.status;
  const item = getTicketQueueItem(ticket, fullStatus);
  const merchant = ticket.merchant_id;
  const merchantCode = merchant?.merchant_code || merchant?.client_code;
  const description = ticket.description?.trim();
  const repeatedDescriptions = [ticket.title, `${item.typeLabel.split(' ')[0]} ${item.title}`].map(value => value?.toLowerCase());

  return <header className="card ticket-summary">
    <div className="ticket-summary-heading">
      <div>
        <div className="ticket-eyebrow">{item.typeLabel}</div>
        <h2 title={ticket.title}>{item.title}</h2>
        {item.context && <p className="ticket-summary-context">{item.context}</p>}
        {description && !repeatedDescriptions.includes(description.toLowerCase()) && <p className="ticket-description">{description}</p>}
      </div>
      {children && <div className="ticket-summary-actions">{children}</div>}
    </div>
    <dl className="ticket-summary-meta">
      <div><dt>Status</dt><dd><span className={`ticket-status is-${item.tone}`} title={fullStatus}>{item.statusLabel}</span></dd></div>
      <div><dt>Owner</dt><dd>{item.owner || 'Unassigned'}</dd></div>
      {merchant && <div><dt>Merchant</dt><dd><Link to={`/merchants/${merchant._id}/view`} className="ticket-summary-merchant">
        {merchant.name || merchantCode}{merchant.name && merchantCode && <small>{merchantCode}</small>}
      </Link></dd></div>}
      {ticket.priority && ticket.priority !== 'normal' && <div><dt>Priority</dt><dd className="ticket-capitalize">{ticket.priority}</dd></div>}
      {ticket.due_date && <div><dt>Due</dt><dd>{new Date(ticket.due_date).toLocaleDateString()}</dd></div>}
    </dl>
  </header>;
};

export default TicketSummary;
